import type { ROUTE_NETWORK } from './router/routes'

import { navigationErrorHandler } from '~/contexts/network/router/navigation-error-handler'
import { navigationGuardNetwork } from '~/contexts/network/router/navigation-guard'
import { getRoutes } from '~/contexts/network/router/router'

import type { IRegisterOpt } from '~/features-shared/libs/interfaces/register'

export function register(options: IRegisterOpt<ROUTE_NETWORK>) {
  options.addRoute(getRoutes())
  options.addNavigationGuard(navigationGuardNetwork)
  options.addNavigationErrorHandler(navigationErrorHandler)
}
